import { render, staticRenderFns } from "./popup-bind-mu-ban.vue?vue&type=template&id=79a23b26&scoped=true"
import script from "./popup-bind-mu-ban.vue?vue&type=script&lang=js"
export * from "./popup-bind-mu-ban.vue?vue&type=script&lang=js"
import style0 from "./popup-bind-mu-ban.vue?vue&type=style&index=0&id=79a23b26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a23b26",
  null
  
)

export default component.exports